// components/ui/Label.js
import React from 'react';

export const Label = ({ className = "", ...props }) => {
  return (
    <label
      className={`text-sm font-medium text-gray-700 ${className}`}
      {...props}
    />
  );
};

export default Label;